import { SearchIcon } from '@ghq-abi/design-system-icons';
import { Input } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { ETolgeeDefault } from '~/shared/enums/ETolgeeDefault';
import { ETolgeeNamespaces } from '~/shared/enums/ETolgeeNamespaces';

export function Search({
  value,
  onChange
}: {
  value: string;
  onChange: (newValue: string) => void;
}) {
  const { t: tDefault } = useTranslate(ETolgeeNamespaces.DEFAULT);

  return (
    <div className="relative flex-1 min-w-[200px] isolate">
      <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none z-[1]" />
      <Input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={tDefault(ETolgeeDefault.COMMON_ACTION_SEARCH)}
        variant="filled"
        className="pl-9"
      />
    </div>
  );
}
